/* global MktoForms2 */

const bankerExists = document.querySelector('.singlebanker');

if (bankerExists) {
	const bankerName = bankerExists.querySelector('.singlebanker-name');
	const bankerImage = bankerExists.querySelector('.singlebanker-img');
	const bankerDetails = bankerExists.querySelector('.singlebanker-text');
	const bankerBio = bankerExists.querySelector('.singlebanker-bio');
	const bankerEmail = bankerExists.querySelector('.singlebanker-email a').innerHTML;
	const bankerExpertise = document.querySelector('.singlebanker-expertise');
	const apptCTA = document.querySelector('.singlebanker-appt-cta');

	const mobileStyling = () => {
		if (window.innerWidth < 579) {
			bankerImage.prepend(bankerName);

			if (apptCTA) {
				bankerExpertise.append(apptCTA);
			}
		} else {
			bankerDetails.prepend(bankerName);

			if (apptCTA) {
				bankerBio.append(apptCTA);
			}
		}
	};

	if (window.innerWidth > 579) {
		const bankerContactInfo = document.querySelector('.singlebanker-contact');
		if (bankerContactInfo.offsetHeight > 25) {
			const bankerContact = document.querySelectorAll('.singlebanker-contact span');

			[].forEach.call(bankerContact, (elem) => {
				const contact = elem;

				contact.style.display = 'block';
				contact.querySelector('svg').style.marginLeft = '0';
			});
		}
	}

	document.addEventListener('DOMContentLoaded', () => {
		mobileStyling();

		window.addEventListener('resize', () => {
			mobileStyling();
		});
	});

	const element = document.querySelector('.section--bankerdetails #mktoForm_1028');
	if (typeof (element) !== 'undefined' && element != null) {
		MktoForms2.loadForm('//app-ab39.marketo.com', '238-OIJ-214', 1028, (form) => {
			form.addHiddenFields({ bankerEmail });

			form.onSuccess(() => {
				form.getFormElem().hide();

				var child = document.getElementById('mktoForm_1028');
				var parent = child.parentNode;form.getFormElem().hide();
				console.log('submit success');
				parent.innerHTML=`</p>
				<p>
				</p>

				<div style="text-align:center;"><b>Thank you for contacting us!</b><br>Your message has been received.<br>We will review your message and get back to you soon.<span data-mce-type="bookmark" style="display: inline-block; width: 0px; overflow: hidden; line-height: 0;" class="mce_SELRES_start">﻿</span></div>
				<p>
				</p>
				<p>`; 

				return false;
			});
		});
	}
}
